import React from 'react';

const WhatsAppIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" {...props}>
    <g>
      <circle cx="25" cy="25" r="25" fill="currentColor" className="text-success-600" />
      <path d="M39.8,23.4A14.64,14.64,0,0,1,25.1,38,15.25,15.25,0,0,1,18,36.2L9.8,38.8,12.5,31a14.84,14.84,0,0,1-2.1-7.5,14.7,14.7,0,0,1,29.4-.1ZM25.1,11.2A12.38,12.38,0,0,0,12.7,23.5a12,12,0,0,0,2.4,7.2l-1.5,4.6,4.8-1.5A12.44,12.44,0,0,0,37.6,23.5,12.53,12.53,0,0,0,25.1,11.2Zm7.4,15.6a3.22,3.22,0,0,0-.7-.4l-2.5-1.2c-.3-.1-.6-.2-.8.2a8.54,8.54,0,0,1-1.1,1.4.59.59,0,0,1-.8.1,11,11,0,0,1-2.9-1.8,9.88,9.88,0,0,1-2-2.5.46.46,0,0,1,.2-.7,2.65,2.65,0,0,0,.5-.6c.2-.2.2-.4.4-.6a.64.64,0,0,0,0-.6c-.1-.2-.8-1.9-1.1-2.7s-.6-.6-.8-.6h-.7a1.85,1.85,0,0,0-1,.4,4.16,4.16,0,0,0-1.3,3,6.45,6.45,0,0,0,1.5,3.7c.2.2,2.5,4,6.2,5.4s3.7,1,4.3.9a3.74,3.74,0,0,0,2.4-1.7A2.82,2.82,0,0,0,32.5,26.8Z" fill="currentColor" className="text-text-inverse" />
    </g>
  </svg>
);

export default WhatsAppIcon;
